import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WizardStepsComponent } from './components/wizard-steps/wizard-steps.component';
import { ToArrayPipe } from '../common/pipes/to-array.pipe';
import { SvgWrapperComponent } from './components/svg-wrapper/svg-wrapper.component';
import { LoaderComponent } from './components/loader/loader.component';
import { SqrtPipe } from '../common/pipes/sqrt.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [
    WizardStepsComponent,
    ToArrayPipe,
    SvgWrapperComponent,
    LoaderComponent,
    SqrtPipe,
  ],
  exports: [
    WizardStepsComponent,
    ToArrayPipe,
    SvgWrapperComponent,
    LoaderComponent,
    SqrtPipe,
  ],
})
export class SharedModule {}
